
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateMeetingTypeDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    templateAgendaItems: new FormControl<Array<any> | undefined>([]),
    active: new FormControl<boolean | undefined>(undefined),
})
;
}
      